




import { Component, Vue } from 'vue-property-decorator'
import Layout from '@/components/Layout.vue'
import { namespace } from 'vuex-class'

const appModule = namespace('app')

@Component({
  components: { Layout },
  metaInfo() {
    return {
      titleTemplate: (titleChunk) => {
        const title = 'Editions Admin'
        return titleChunk ? `${titleChunk} - ${title}` : title
      }
    }
  }
})
export default class Admin extends Vue {
  @appModule.Action initApp!: (helloCallback: (username: string) => void) => void

  async beforeMount() {
    await this.initApp((username: string) => {
      this.$notify({
        title: this.$t('welcome').toString(),
        message: this.$t('hello_username', { username }).toString(),
        position: 'bottom-right',
        duration: 3500
      })
    })
  }
}
